import React from 'react';
import { styled } from 'styled-components';
import { Colors } from '../../../../play-core/styles/Colors';
import { Viewports } from '../../../../play-core/styles/Viewports';
import { jsx as _jsx } from "react/jsx-runtime";
export const MessageContainer = ({
  children,
  type = 'Info',
  className
}) => /*#__PURE__*/_jsx(Container, {
  className: className,
  children: /*#__PURE__*/_jsx(TextContainer, {
    type: type,
    children: children
  })
});
const Container = styled.div.withConfig({
  displayName: "MessageContainer__Container",
  componentId: "sc-6kj84v-0"
})(["margin:120px 32px 50px;display:flex;align-items:center;justify-content:center;", "{margin-top:75px;margin-bottom:40px;}"], Viewports.for('small'));
const TextContainer = styled.div.withConfig({
  displayName: "MessageContainer__TextContainer",
  componentId: "sc-6kj84v-1"
})(["min-height:56px;border:1px solid ", ";display:flex;align-items:center;justify-content:center;"], props => props.type === 'Info' ? Colors.GREY_969696 : Colors.ERROR);